// import React, { useState } from "react";
import { RupeesIcon, ResetIcon } from "../../components/HeaderSidebarIcons";
import { Button } from "@heroui/react";

const stakeNum = [5, 10, 50, 100, 200, 500, 1000, 5000];

export default function Stake({
  selectedStake,
  setSelectedStake,
  stakeInput,
  setStakeInput,
  minMaxMap,
  selectedType,
}) {
  return (
    <div className="border-t border-b border-gray-300 bg-white  p-1  w-full">
      <h1 className="text-center font-medium  text-m_red">Select Amount</h1>
      {/* <span>Rate : 350</span> */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-1">
        <div className="grid grid-cols-4 sm:grid-cols-4 gap-4 w-full p-2">
          {stakeNum.map((number, index) => (
            <Button
              key={index}
              size="md"
              onClick={() => setSelectedStake(number)}
              className={`h-8 min-w-[60px] sm:min-w-[100px] w-full font-semibold border border-gray-300 
                ${
                  selectedStake === number
                    ? "bg-m_peach text-white"
                    : "bg-white"
                }
                hover:bg-m_peach hover:text-white transition-colors`}
              variant="flat"
              color="default"
              style={{
                borderRadius: "5px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div className="flex flex-col items-center">
                <div className="flex">
                  <span className="text-sm text-black-50">
                    <RupeesIcon />
                  </span>
                  <span>{number}</span>
                </div>
              </div>
            </Button>
          ))}
        </div>
      </div>
      {/* <div className="p-3 mt-1">
        <div className="flex justify-end mb-1">
          <div className="flex items-center text-xl font-medium text-right">
            Selected Stake:
            <span id="total-stake" className="ml-1">
              {selectedStake !== null ? selectedStake : "0"}
            </span>
            <span
              className="bg-white font-bold p-1 text-blue-800 cursor-pointer"
              onClick={() => setSelectedStake(0)}
            >
              <ResetIcon className="w-6 h-4 font-bold" />
            </span>
          </div>
        </div>
        <div className="flex justify-end mb-1">
          <div className="flex items-center text-md font-medium text-right mr-14">
            <span>
              ({minMaxMap[selectedType]?.min_stake} -{" "}
              {minMaxMap[selectedType]?.max_stake})
            </span>
          </div>
        </div>
      </div> */}
    </div>
  );
}
